import * as PIXI from 'pixi.js';
import * as TweenJS from "slotworks/utils/tween";
import { BounceZoomIn, BounceZoomOut } from "slotworks/graphics/animation/base-animations";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";
import Contract from "slotworks/utils/contract";
import { parallel } from "slotworks/utils/race-utils";
import HarleyComponents from "components/components";
import { FadeInLayersCommand } from 'commands/fade-layers-command';
import soundManager from 'slotworks/sound/sound-manager';

export default class FreespinsNoBoostersTransitions extends AbstractSceneTransition {

    public in(): Contract<void> {
        return parallel([
            () => BounceZoomIn([
                Layers.Prompts.getSprite("value"),
            ], 500),
            () => BounceZoomIn([
                Layers.Prompts.getSprite("freespins_title"),
            ], 500, 100),
            () => BounceZoomIn([
                Layers.Prompts.getSprite("Harlequins"),
                Layers.Prompts.getSprite("btn-continue"),
                Layers.Prompts.getSprite("btn-continue-lbl"),                
            ], 500, 200),
        ]);
    }

    public out(): Contract<void> {
        soundManager.customEvent("bonus_music_stop");
        soundManager.customEvent("freespins_music");
        HarleyComponents.harley.hide();
        Layers.Background.setScene("freespins").execute();
        FadeInLayersCommand([
            Layers.MatrixBackground,
            Layers.MatrixContent,
            Layers.MatrixForeground,
            Layers.SymbolAnimations,
            Layers.BetBar,
            Layers.SmartButton,
            Layers.Banners,
            Layers.Footer,
            Layers.Custom.get("Messages"),
            Layers.Custom.get("MatrixNeon")
        ]).execute();
        return parallel([
            () => BounceZoomOut([
                Layers.Prompts.getSprite("value")
            ], 500, 200),
            () => BounceZoomOut([
                Layers.Prompts.getSprite("freespins_title"),
            ], 500, 100),
            () => BounceZoomOut([
                Layers.Prompts.getSprite("Harlequins"),
                Layers.Prompts.getSprite("btn-continue"),
                Layers.Prompts.getSprite("btn-continue-lbl"),
            ], 500),
        ])
    }
}
